import update from 'immutability-helper';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import {
  DispatchContext,
  StateContext,
} from '../../contexts/use-menu-editor-context';
import VariantItem from './variant-item';

const ListContainer = styled.div`
  padding-bottom: 14px;
`;

function VariantList(props) {
  const {
    parent,
    menuIdx,
    categoryIdx,
    productIdx,
    setIsEditMode,
    isEditMode,
    isExpanded,
    setIsExpanded,
  } = props;

  const [isUpdatingVariantOrder, setIsUpdatingVariantOrder] = useState(false);

  const context = useContext(StateContext);
  const dispatch = useContext(DispatchContext);

  const {
    state: { menus },
    client,
  } = context;

  const setVariants = async newVariants => {
    const menusCloned = [...menus];
    menusCloned[menuIdx].children[categoryIdx].children[productIdx].children =
      newVariants;

    dispatch({ type: 'FETCH_MENUS_RESPONSE', payload: menusCloned });
    setIsUpdatingVariantOrder(true);

    try {
      const variantPositions = newVariants.map(newVariant => {
        const menuObj = {
          state: 'reposition',
          menu: {
            id: newVariant.id,
            position: newVariants.indexOf(newVariant),
          },
        };
        return menuObj;
      });

      await client.post('/menu-operations', variantPositions);
    } catch (err) {
      const oldMenus = [...menus];
      console.log(err);
      dispatch({ type: 'FETCH_MENUS_RESPONSE', payload: oldMenus });
    } finally {
      setIsUpdatingVariantOrder(false);
    }
  };

  const reorderCards = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    if (result.source && !!result.destination) {
      if (result.destination.index === result.source.index) {
        return;
      }
      const dragCard = parent.children[result.source.index];
      const newVariants = update(parent.children, {
        $splice: [
          [result.source.index, 1],
          [result.destination.index, 0, dragCard],
        ],
      });
      setVariants(newVariants);
    }
  };

  const grid = 0;
  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: 0 * grid,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const isAnyChildExpanded = (parent.children || []).some(variant => {
    return Boolean(isExpanded[variant.id]);
  });
  return (
    <ListContainer>
      <DragDropContext onDragEnd={reorderCards}>
        <Droppable droppableId="droppable-variant">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {(parent.children || []).map((variant, idx) => {
                return (
                  <Draggable
                    key={variant.id}
                    draggableId={variant.id}
                    index={idx}
                    isDragDisabled={
                      isUpdatingVariantOrder || isEditMode || isAnyChildExpanded
                    }
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <VariantItem
                          key={`variant-item-${variant.id}`}
                          menuIdx={menuIdx}
                          categoryIdx={categoryIdx}
                          productIdx={idx}
                          variant={variant}
                          parent={parent}
                          setIsEditMode={setIsEditMode}
                          isEditMode={isEditMode}
                          isExpanded={isExpanded}
                          setIsExpanded={setIsExpanded}
                          isAnyChildItemExpanded={isAnyChildExpanded}
                        />
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </ListContainer>
  );
}

VariantList.propTypes = {
  parent: PropTypes.object.isRequired,
};

export default VariantList;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/VariantList/variant-list.jsx